// @flow
import { SOCIAL_NETWORKS_MAP } from 'core/constants/socials'
import type { SocialProvider } from 'core/types'

/**
 * Возвращает название соц.сети
 */
export const getSocialNetTitle = (provider: SocialProvider): string => SOCIAL_NETWORKS_MAP[provider].title
